const BASE = '/api';

async function req(path, opts = {}) {
  const isForm = typeof FormData !== 'undefined' && opts.body instanceof FormData;
  const headers = isForm
    ? { ...(opts.headers || {}) }                        // el navegador pone el boundary multipart
    : { 'Content-Type': 'application/json', ...(opts.headers || {}) };
  const res = await fetch(BASE + path, { ...opts, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Error' }));
    throw new Error(err.error || `Error ${res.status}`);
  }
  return res.json();
}

export const api = {
  categories: () => req('/categories'),
  products: (q = '') => req('/products' + q),
  product: (slug) => req('/products/' + slug),
  settings: () => req('/settings'),
  createOrder: (body) => req('/orders', { method: 'POST', body: JSON.stringify(body) }),
  trackOrder: (codigo, telefono) => req('/orders/track', { method: 'POST', body: JSON.stringify({ codigo, telefono }) }),
  createCustomOrder: (formData) => req('/custom-orders', { method: 'POST', body: formData }),
  // admin
  login: (password) => req('/admin/login', { method: 'POST', body: JSON.stringify({ password }) }),
  adminGet: (path, token) => req('/admin' + path, { headers: { Authorization: 'Bearer ' + token } }),
  adminSend: (path, method, body, token) =>
    req('/admin' + path, { method, body: JSON.stringify(body), headers: { Authorization: 'Bearer ' + token } }),
  // gestor de imágenes
  adminUpload: (formData, token) =>
    req('/admin/uploads', { method: 'POST', body: formData, headers: { Authorization: 'Bearer ' + token } }),
  adminMedia: (token) =>
    req('/admin/media', { headers: { Authorization: 'Bearer ' + token } }),
  adminMediaDelete: (filename, token) =>
    req('/admin/media/' + encodeURIComponent(filename), { method: 'DELETE', headers: { Authorization: 'Bearer ' + token } })
};
